import { render } from "./VoucherTplDialog.vue?vue&type=template&id=2a8a9dc1&scoped=true"
import script from "./VoucherTplDialog.vue?vue&type=script&lang=js"
export * from "./VoucherTplDialog.vue?vue&type=script&lang=js"

import "./VoucherTplDialog.vue?vue&type=style&index=0&id=2a8a9dc1&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8a9dc1"]])

export default __exports__